import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import type { CreateableNode } from "../types/index.ts";
import { useLibraryContext } from "./LibraryContext.ts";
import type { NodeSelectionCriteria } from "./shared.ts";

const noDefinitions: CreateableNode[] = [];

export const useFindDefinitions = (criteria: NodeSelectionCriteria) => {
  const { findDefinitions } = useLibraryContext();

  const { data, status } = useQuery<CreateableNode[]>({
    queryKey: ["creatable-nodes", JSON.stringify(criteria)],
    queryFn: () => findDefinitions(criteria),
  });

  return useMemo(() => ({ fetchState: status, definitions: data ?? noDefinitions }), [data, status]);
};
